import React from "react";
import "./FAQ.css";
import Topbar from "../../Components/Topbar/Topbar";
import Navbar from "../../Components/Navbar/Navbar";
import Banner2 from "../../Components/Banner/Banner2";
import GetInTouch from "../Home/Components/GetInTouch/GetInTouch";
import Footer from "../../Components/Footer/Footer";
import FaqQuestions from "./Components/FaqQuestions/FaqQuestions";
const FAQ = () => {
  return (
    <div className="faq__screen">
      <Topbar />
      <Navbar />
      <Banner2
        heading="FAQ"
        description="Frequently asked question about Serenetax!"
      />
      <FaqQuestions />
      <GetInTouch />
      <Footer />
    </div>
  );
};

export default FAQ;
